import React, { Component } from "react";
import ls from 'localstorage-slim';
import { LayoutContext } from "../../../modules/ContextModules/LayoutContext";
import storyMap from './doc/台灣好行.json';

import "./TopBar.css"
export class TopBar extends Component {
    static contextType = LayoutContext;

    constructor(props) {
        super(props);

        this.state = {
            isLogined: false,
        };
    }

    componentDidMount() {
        let lsInfo = ls.get("userInfo", { decrypt: true });
        if (lsInfo) {
            this.setState({ isLogined: true });
        }
    }

    render() {
        return (
            <div className="topBar noPrint">
                <div className="topBar__tab" onClick={(e) => { this.openSensorThings(); }}>民生公共物聯資訊<div className="triangle03" /></div>
                {this.state.isLogined ? <div className="topBar__tab" onClick={(e) => { this.tabClick("kmlUploadTool") }}>道路養護成果上傳<div className="triangle03" /></div> : null}
                {this.state.isLogined ? <div className="topBar__tab" onClick={(e) => { this.tabClick("readilyAvailableHouseTool") }}>既有成屋檢核工具<div className="triangle03" /></div> : null}
                <div className="topBar__tab" onClick={(e) => { this.tabClick("travelDiaryTool") }}>旅圖日記<div className="triangle03" /></div>
                {/*<div className="topBar__tab" onClick={(e) => { this.gotoBestCommentator_OnClick() }}>故事地圖編輯器<div className="triangle03" /></div>*/}
                <div className="topBar__tab topBar__tab-drop-down" onClick={(e) => { /*this.openBestCommentatorPlayer()*/ }}>使用者故事<div className="triangle03" />
                    {this.dropmenu()}
                </div>
                {this.state.isLogined ? <div className="topBar__tab" onClick={(e) => { this.tabClick("threeDBuildingTool") }}>套疊3D建物模型<div className="triangle03" /></div> : null}
            </div>
        );
    }

    dropmenu() {
        return (
            <ul className="topBar__tab-dropDownMenu" >
                <li>
                    <div onClick={(e) => { this.gotoBestCommentator_OnClick() }}>使用者故事編輯器</div>
                </li>
                <li>
                    <div onClick={(e) => { this.openBestCommentatorPlayer() }}>使用者故事播放器</div>
                </li>
            </ul>
        );
    }

    gotoBestCommentator_OnClick() {
        const link = document.createElement("a");
        link.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}storymap/`;
        link.target = "_blank";
        link.click();
        link.remove();
    }

    openBestCommentatorPlayer() {
        let blob = new Blob([JSON.stringify(storyMap)], { type: 'application/json' });

        let file = new File([blob],"台灣好行.json");
        this.BestCommentatorPlayer = new window.ov.Widget.BestCommentatorPlayer({
            view: window.gMainMap.TerrainView,
            storySrcList: [file]
        });
        this.BestCommentatorPlayer._WidgetUI._PosX = 500;
        let bcpCss = document.getElementsByClassName("ov-widget-bestCommentatorPlayer")[0];
        bcpCss.style.left = "500px";
    }

    openSensorThings() {
        this.DTM = new window.ov.Widget.SensorThings({ listX: 500, view: window.gMainMap.TerrainView, proxy: "OviewProxy?https://sample.pilotgaea.com.tw/sensorthings.ashx?" });
        this.DTM._WidgetUI._PosX = 500;
        let dtmCss = document.getElementsByClassName("ov-widget-DTM")[0];
        dtmCss.style.left = "500px";
    }

    tabClick = (constextKey) => {
        this.context
            .draggableWindowContext[constextKey]
            .update({
                isOpened: true,
                isMinimized: false
            });
    }
}